export const MolList = ['H2O', 'C2', 'LiH', 'H2'];

export const BasisList = [
    {value: "STO-3G", label: "STO-3G"},
    {value: "6-31G", label: "6-31G"},
    {value: "CC-PVDZ", label: "CC-PVDZ", disabled: true},
];

export const AccuracyList = [10, 9, 8, 7, 6, 5, 4, 3];